/**
 * Tabindex functionality
 *
 * Required to disable tabindex on wprm-comment-rating elements because of how it's shown on the page.
 */
document.addEventListener( 'DOMContentLoaded', function() {
	document.querySelectorAll( '[name="wprm-comment-rating"]' ).forEach( function( el ) {
		el.setAttribute( 'tabindex', '-1' );

		// Disable tabindex for any focusable children
		el.querySelectorAll( '[tabindex]' ).forEach( function( child ) {
			child.setAttribute( 'tabindex', '-1' );
		});
	});
});
